import styled from 'styled-components'

export default styled.div`
	.wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 16px;
		background: #ffffff;
		border: 1px solid #efefef;
		border-radius: 6px;
		&:hover {
			border: 1px solid rgb(152, 189, 255);
		}
		&.priority {
			border: 1px solid rgb(152, 189, 255);
			background: #f0f7ff;
		}
		.wrap-badge {
			display: flex;
			align-items: center;
			flex-wrap: no-wrap;
			&.reverted-order {
				flex-direction: row-reverse;
				justify-content: start;
			}
			&__badge {
				display: flex;
				flex-wrap: nowrap;
				align-items: center;
				color: white;
				border-radius: 30px;
				font-size: 11px;
				font-weight: bold;
				padding: 4px 10px 4px 7px;
				vertical-align: bottom;
				opacity: 1;
				text-transform: capitalize;
				margin-right: 5px;
				margin-top: 5px;
				a {
					color: white;
					white-space: nowrap;
				}
				svg {
					position: relative;
					margin-right: 5px;
				}
				transform: translateY(-6px);
				margin-bottom: -4px;

				&-blue {
					background: #005aff;
				}
				&-red {
					background: #ff4a53;
				}
			}
		}
		.job {
			display: flex;
			align-items: center;
			gap: 24px;
			position: relative;
			&__image {
				background-color: #fff;
				.image {
					width: 117px;
					height: 117px;
					border-radius: 10px;
				}
				border-radius: 10px;
			}
			.notification-tooltip {
				background: #bee9f7;
				font-size: 13px;
				padding: 5px 10px;
				position: absolute;
				right: -10px;
				top: -35px;
				white-space: nowrap;
			}
			.arrow-bottom {
				width: 0px;
				height: 0;
				border-top: 6px solid #bee9f7;
				border-right: 6px solid transparent;
				border-left: 6px solid transparent;
				position: absolute;
				z-index: 2;
				right: 15px;
				top: -10px;
			}
			&__info {
				width: 100%;
				height: 100%;
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				font-weight: 400;
				gap: 4px;
				p {
					margin: 0;
				}

				&-title {
					font-weight: 500;
					font-size: 16px;
					line-height: 24px;
					color: #333333;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					width: 75%;
					&.--red {
						font-weight: 700;
						font-size: 17px;
						color: #ff4a53;
					}
					&:hover {
						color: #ff7d55;
					}
				}
				&-subTitle {
					font-size: 14px;
					line-height: 17px;
					color: #333333;
					&:hover {
						color: #ff7d55;
					}
				}
				&-text {
					font-size: 13px;
					line-height: 20px;
					color: #777;
					&.salary {
						color: #ff7d55;
						font-weight: 500;
					}
					strong {
						color: #777;
					}
				}
				&-tags {
					display: flex;
					align-items: center;
					flex-wrap: wrap;
					&.benefits-gap {
						gap: 20px;
					}
					&.skills-gap {
						gap: 8px;
					}
					.--relative {
						position: relative;
					}
				}
			}
			&__salary {
				position: absolute;
				top: 0;
				right: 0;
				color: #ff7d55;
				font-weight: 500;
			}
			&__button {
				display: flex;
				align-items: center;
				gap: 16px;
			}
			&__tool {
				display: flex;
				align-items: center;
				&-item {
					font-weight: 500;
					font-size: 13px;
					line-height: 16px;
					position: relative;
					&.--blue {
						span {
							font-weight: 700;
							color: #005aff;
							white-space: nowrap;
						}
					}
					&.--green {
						span {
							font-weight: 400;
							color: #6fb920;
							white-space: nowrap;
						}
					}
				}
				&-mathching {
					white-space: pre-wrap;
				}
				.bookmark {
					cursor: pointer;
					padding-left: 16px;
				}
			}
			.new {
				padding: 4px;
				font-weight: 700;
				font-size: 12px;
				line-height: 15px;
				color: #e76560;
				text-transform: uppercase;
			}
			.block-bottom {
				display: flex;
				justify-content: space-between;
				align-items: flex-end;
				flex-wrap: nowrap;
				&__skill {
					display: flex;
					align-items: center;
					flex-wrap: wrap;
					gap: 4px;
				}
				&__tool {
					display: flex;
					align-items: center;
					flex-wrap: nowrap;
					gap: 4px;
					white-space: nowrap;
				}
			}
		}
	}
	@media all and (max-width: 992px) {
		.wrap {
			overflow: hidden;
			padding: 8px;
			border-radius: 0px;
			.wrap-badge {
				transform: translateX(20px);
				flex-wrap: wrap;
				&.reverted-order {
					justify-content: end;
				}
			}
			.job {
				gap: 8px;
				&__image {
					background-color: #fff;
					.image {
						width: 80px;
						height: 80px;
					}
				}
				&__info {
					gap: 2px;
					&-title {
						width: 100%;
						overflow: unset;
						text-overflow: unset;
						display: block;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: unset;
					}

					&-tags {
						&.benefits-gap {
							gap: 4px;
						}
						&.skills-gap {
							gap: 2px;
						}
					}
				}
			}
		}
	}
`
